import * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import * as transformers from '@attain-apps/transformers'
import gql from 'graphql-tag'

const DOC = gql`
  query SpaceFunctions(
    $tenantId: ID!
    $zoneId: ID!
    $appId: ID!
    $scenarioId: ID!
  ) {
    tenant(id: $tenantId) {
      zone(id: $zoneId) {
        app(id: $appId) {
          scenario(id: $scenarioId) {
            extra {
              space {
                spaceFunctions {
                  code
                  description
                  id
                  idcCategorization {
                    category {
                      code
                      id
                      name
                    }
                    subcategory {
                      code
                      id
                      name
                    }
                  }
                  isExclusive
                  isRequiredForMatchingPayroll
                  isSponsored
                  name
                }
              }
            }
          }
        }
      }
    }
  }
`

const TRANSFORMER = graphql.transformers.OUT.default(
  graphql.transformers.OUT.select<
    graphql.schema.SpaceFunctionsQuery,
    ents.extra.space.Function[],
    'tenant'
  >(
    'tenant',
    graphql.transformers.OUT.select(
      'zone',
      graphql.transformers.OUT.select(
        'app',
        graphql.transformers.OUT.select(
          'scenario',
          graphql.transformers.OUT.select(
            'extra',
            graphql.transformers.OUT.select(
              'space',
              graphql.transformers.OUT.select(
                'spaceFunctions',
                graphql.transformers.OUT.list(
                  graphql.transformers.OUT.object({
                    code: transformers.PASS_THROUGH,
                    description: transformers.PASS_THROUGH,
                    id: graphql.transformers.OUT.validate(
                      transformers.PASS_THROUGH,
                      ents.extra.space.Function.Id.assertIsId,
                      { warnOnly: true },
                    ),
                    idcCategorization: graphql.transformers.OUT.object({
                      category: graphql.transformers.OUT.nonNull(
                        graphql.transformers.OUT.object({
                          code: transformers.PASS_THROUGH,
                          id: graphql.transformers.OUT.validate(
                            transformers.PASS_THROUGH,
                            ents.core.dms.data.Record.Id.assertIsId,
                            { warnOnly: true },
                          ),
                          name: transformers.PASS_THROUGH,
                        }),
                      ),
                      subcategory: graphql.transformers.OUT.object({
                        code: transformers.PASS_THROUGH,
                        id: graphql.transformers.OUT.validate(
                          transformers.PASS_THROUGH,
                          ents.core.dms.data.Record.Id.assertIsId,
                          { warnOnly: true },
                        ),
                        name: transformers.PASS_THROUGH,
                      }),
                    }),
                    isExclusive: graphql.transformers.OUT.default(
                      transformers.PASS_THROUGH,
                      false,
                    ),
                    isRequiredForMatchingPayroll:
                      graphql.transformers.OUT.default(
                        transformers.PASS_THROUGH,
                        false,
                      ),
                    isSponsored: graphql.transformers.OUT.default(
                      transformers.PASS_THROUGH,
                      false,
                    ),
                    name: transformers.PASS_THROUGH,
                  }),
                  { onNullish: 'remove' },
                ),
              ),
            ),
          ),
        ),
      ),
    ),
  ),
  [],
)
export const executor = graphql.createExecutor<
  graphql.schema.SpaceFunctionsQuery,
  ents.extra.space.Function[],
  graphql.schema.SpaceFunctionsQueryVariables
>({
  query: DOC,
  transformer: TRANSFORMER,
})
